export default xs => xs.filter((x, i) => xs.indexOf(x) === i);
